/**
 * Colagea Logo Component
 * Renders the Colagea brand logo as an image.
 * Replaces the previous FluffCo SVG logo.
 * Keeps the same interface (className, color props) for backward compatibility.
 */

interface FluffLogoProps {
  className?: string;
  color?: string;
}

export default function FluffLogo({ className = "h-10 w-auto" }: FluffLogoProps) {
  return (
    <img
      src="https://d2xsxph8kpxj0f.cloudfront.net/310519663243023818/kXYViC6LoVarhABtxw9dmA/colagea-logo_f0a5a7f3.png"
      alt="Colagea"
      className={className}
      loading="eager"
      decoding="async"
    />
  );
}
